export enum AssistantType {
  LegalAssistant = 'LegalAssistant'
}

export enum ReviewingAssistantType {
  DocumentReviewingAssistant = 'DocumentReviewingAssistant'
}

export type ChatAssistant = AssistantType | ReviewingAssistantType;
